<mat-form-field appearance="outline">
  <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
  <input #input (input)="filter()" (focus)="filter()" type="text" [placeholder]="easControl.field.widget?.placeholder ?? ''" matInput [formControl]="easControl.control" [matAutocomplete]="auto">
  <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayFn()">
    <mat-option *ngIf="$isLoading()" class="is-loading">Loading...</mat-option>
    <mat-option *ngIf="errorMsg" class="error">{{ errorMsg }}</mat-option>
    <ng-container *ngIf="!$isLoading()">
      <mat-option *ngFor="let option of categories$ | async" [value]="option[easControl.field.options?.key ?? 'id']">
        {{option.name}}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
</mat-form-field>
